import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}) {
  const directions = {
    up: {
      y: 40,
      x: 0
    },
    down: {
      y: -40,
      x: 0
    },
    left: {
      x: 40,
      y: 0
    },
    right: {
      x: -40,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  return <motion.div initial={{
    opacity: 0,
    ...directions[direction]
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-238">
      {children}
    </motion.div>;
}
export function StaggerContainer({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <motion.div initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-100px'
  }} variants={{
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  }} className={className} data-id="element-239">
      {children}
    </motion.div>;
}
export function StaggerItem({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <motion.div variants={{
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  }} className={className} data-id="element-240">
      {children}
    </motion.div>;
}
export function CTAButton({
  className = '',
  onClick
}: {
  className?: string;
  onClick?: () => void;
}) {
  const defaultClick = () => window.open('https://pay.hotmart.com/M105893194L', '_blank');
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-241">
      <motion.button whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.98
    }} className="bg-brand-red text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_8px_30px_rgb(185,28,28,0.3)] hover:bg-red-800 transition-colors w-full max-w-xl text-center" onClick={onClick || defaultClick} data-id="element-242">
        SÍ, QUIERO CENAS SIN BATALLAS AHORA
      </motion.button>
      <p className="text-sm text-gray-600 mt-4 flex items-center justify-center gap-2 text-center" data-id="element-243">
        <Shield className="w-4 h-4 text-brand-green" data-id="element-244" />
        Pago seguro. Acceso instantáneo en formato PDF compatible con todos los
        dispositivos.
      </p>
    </div>;
}